import styled from "styled-components";

const size = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
};

export const device = {
  mobile: `(min-width: ${size.sm})`,
  tablet: `(min-width: ${size.md})`,
  desktop: `(min-width: ${size.lg})`,
};

export const PageHeaderContainer = styled.div`
  height: 100%;
  position: relative;
`;

export const LineDivider = styled.div`
  content: "";
  display: block;
  position: relative;
  width: 50%;
  border: 2px solid #898989;
  margin: 20px auto;

  @media ${device.tablet} {
    width: 70%;
    border: 1px solid #898989;
  }
`;

export const Divider = styled.hr`
  margin: auto;
  position: relative;
  height: 9px;
  width: 9px;
  border: transparent;
  overflow: visible;
  background-image: url('data:image/svg+xml;utf8,<svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg"><rect x="0.75" y="0.5" width="8" height="8" rx="4" fill="%23008080" /></svg>');

  &:before {
    position: absolute;
    height: 9px;
    width: 10px;
    content: "";
    background-image: url('data:image/svg+xml;utf8,<svg width="10" height="9" viewBox="0 0 10 9" xmlns="http://www.w3.org/2000/svg"><path d="M3.91043 1.29752C4.30449 0.688518 5.19551 0.688519 5.58957 1.29752L9.25143 6.95675C9.68196 7.62211 9.20436 8.5 8.41186 8.5H1.08814C0.29564 8.5 -0.181954 7.62211 0.248574 6.95675L3.91043 1.29752Z" fill="%23008080" /></svg>');
    left: -18px;
  }

  &:after {
    position: absolute;
    height: 9px;
    width: 9px;
    content: "";
    background-image: url('data:image/svg+xml;utf8,<svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg"><rect x="0.75" y="0.5" width="8" height="8" rx="1" fill="%23008080" /></svg>');
    right: -18px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 0 5% 0;
  background-color: #000;

  ${Divider} {
    margin: 0;
  }

  @media ${device.desktop} {
    margin-top: -80px;
  }
`;

export const Title = styled.p`
  margin: 10px;
  font-size: 2.5em;
  font-weight: bold;
  color: #fff;
`;

export const MainTitle = styled.h2`
  font-size: 2.5em;
`;
